import Notice from './notice.vue'
export default Notice
